/*!
    * @product/scmp-sdk 1.3.0
    * built by undefined
  */
function a(...d){var n;typeof window>"u"||!((n=window)!==null&&n!==void 0&&(n=n.dataLayer)!==null&&n!==void 0&&n.push)||window.dataLayer.push(arguments)}export{a};
//# sourceMappingURL=chunk-SOSDSERZ.js.map
